import { render, staticRenderFns } from "./UserNameIcon.vue?vue&type=template&id=1bea3fff&"
import script from "./UserNameIcon.vue?vue&type=script&lang=js&"
export * from "./UserNameIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports